'use strict';



// --- MOBILE GALLERY SWIPE ---
(function initSwipeGallery() {
  const gallery = document.querySelector('[data-gallery]');
  const mainImg = document.querySelector('[data-gallery-main]');
  if (!gallery || !mainImg) return;

  const mainWrap = mainImg.closest('.product-gallery__main') || mainImg.parentElement;
  if (mainWrap) mainWrap.style.touchAction = 'pan-y';

  const SWIPE_THRESHOLD = 28; // px avant de valider le changement d'image (plus réactif qu'avant)
  const DRAG_DAMPING = 0.55; // ralentit légèrement le suivi du doigt pour un geste plus doux
  const DIRECTION_LOCK = 6; // px avant de déterminer si le geste est horizontal ou vertical

  let startX = 0;
  let startY = 0;
  let currentX = 0;
  let isDragging = false;
  let isHorizontal = null; // null = pas encore déterminé
  let galleryWidth = gallery.offsetWidth;

  function setTransition(enabled) {
    mainImg.style.transition = enabled ? 'transform .26s cubic-bezier(.22,.61,.36,1), opacity .26s ease' : 'none';
  }

  function getThumbs() { return [...document.querySelectorAll('[data-gallery-thumb]')]; }

  gallery.addEventListener('touchstart', e => {
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    currentX = startX;
    isDragging = true;
    isHorizontal = null;
    galleryWidth = gallery.offsetWidth || 1;
    setTransition(false);
  }, { passive: true });

  gallery.addEventListener('touchmove', e => {
    if (!isDragging) return;
    currentX = e.touches[0].clientX;
    const currentY = e.touches[0].clientY;
    const dx = currentX - startX;
    const dy = currentY - startY;

    if (isHorizontal === null && (Math.abs(dx) > DIRECTION_LOCK || Math.abs(dy) > DIRECTION_LOCK)) {
      isHorizontal = Math.abs(dx) > Math.abs(dy);
    }

    if (isHorizontal) {
      // Bloque le scroll/swipe de la page UNIQUEMENT pendant un geste horizontal confirmé,
      // pour que seule l'image bouge et pas la page entière (le scroll vertical reste libre).
      e.preventDefault();
      mainImg.style.transform = `translateX(${dx * DRAG_DAMPING}px)`;
    }
  }, { passive: false });

  gallery.addEventListener('touchend', () => {
    if (!isDragging) return;
    isDragging = false;
    if (!isHorizontal) { isHorizontal = null; return; }
    isHorizontal = null;
    const diff = startX - currentX;
    setTransition(true);

    if (Math.abs(diff) < SWIPE_THRESHOLD) {
      mainImg.style.transform = 'translateX(0)';
      return;
    }

    const thumbs = getThumbs();
    const active = document.querySelector('[data-gallery-thumb].active');
    const currentIndex = thumbs.indexOf(active);
    const dir = diff > 0 ? 1 : -1; // 1 = suivant, -1 = précédent
    const nextIndex = Math.min(Math.max(currentIndex + dir, 0), thumbs.length - 1);

    if (nextIndex === currentIndex) {
      mainImg.style.transform = 'translateX(0)';
      return;
    }

    const exitX = dir > 0 ? -galleryWidth * 0.3 : galleryWidth * 0.3;
    mainImg.style.transform = `translateX(${exitX}px)`;
    mainImg.style.opacity = '0';

    setTimeout(() => {
      thumbs[currentIndex].classList.remove('active');
      thumbs[nextIndex].classList.add('active');
      mainImg.src = thumbs[nextIndex].dataset.src;
      if (thumbs[nextIndex].dataset.alt) mainImg.alt = thumbs[nextIndex].dataset.alt;
      setTransition(false);
      mainImg.style.transform = `translateX(${-exitX * 0.5}px)`;
      requestAnimationFrame(() => {
        setTransition(true);
        mainImg.style.transform = 'translateX(0)';
        mainImg.style.opacity = '1';
      });
    }, 200);
  }, { passive: true });
})();

/* Rivelia: demi-pointures mocassin beige a gland, element interne */
(function(){
  if(location.pathname !== '/products/mocassin-en-daim-beige-a-gland') return;

  function fixHalfSizeSpans(){
    document.querySelectorAll('span.variant-option').forEach(function(option){
      var raw = (option.textContent || '').trim();
      if(!/^\d+\.\d+$/.test(raw)) return;

      var label = option.closest('label');
      var input = label && label.previousElementSibling;
      var selected = input && input.checked;

      option.style.setProperty('font-size', '13px', 'important');
      option.style.setProperty('width', '44px', 'important');
      option.style.setProperty('height', '40px', 'important');
      option.style.setProperty('padding', '7px 14px', 'important');
      option.style.setProperty('border-radius', '2px', 'important');
      option.style.setProperty('border', '0.5px solid #e5e0d8', 'important');
      option.style.setProperty('background', selected ? '#111111' : 'transparent', 'important');
      option.style.setProperty('color', selected ? '#ffffff' : '#111111', 'important');
      option.style.setProperty('display', 'inline-block', 'important');

      if(label) label.style.setProperty('width', '44px', 'important');
    });
  }

  fixHalfSizeSpans();
  document.addEventListener('change', fixHalfSizeSpans);
  document.addEventListener('shopify:section:load', fixHalfSizeSpans);
  new MutationObserver(fixHalfSizeSpans).observe(document.documentElement, {childList:true, subtree:true});
})();

/* Rivelia community auto-scroll (infinite loop) */
(function(){
  const track = document.querySelector('[data-community-scroll]');
  if(!track) return;
  let paused = false;
  const halfWidth = () => track.scrollWidth / 2;

  track.addEventListener('mouseenter', ()=>paused=true);
  track.addEventListener('mouseleave', ()=>paused=false);
  track.addEventListener('touchstart', ()=>paused=true, {passive:true});
  track.addEventListener('touchend', ()=>paused=false);

  function loop(){
    if(!paused){
      track.scrollLeft += 0.5;
      if(track.scrollLeft >= halfWidth()) track.scrollLeft = 0;
    }
    requestAnimationFrame(loop);
  }
  requestAnimationFrame(loop);
})();

/* Rivelia sticky mobile ATC bar + size picker */
(function(){
  const bar = document.querySelector('[data-sticky-atc]');
  const realBtn = document.querySelector('[data-atc-btn]');
  if(!bar || !realBtn) return;

  let paused = false;
  const io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      bar.classList.toggle('show', !e.isIntersecting && window.innerWidth <= 768);
    });
  }, {threshold: 0});
  io.observe(realBtn);
  window.addEventListener('resize', function(){ if(window.innerWidth > 768) bar.classList.remove('show'); });

  const priceEl = document.querySelector('[data-product-price]');
  const stickyPrice = bar.querySelector('[data-sticky-atc-price]');
  if(priceEl && stickyPrice){
    new MutationObserver(function(){ stickyPrice.textContent = priceEl.textContent; })
      .observe(priceEl, {childList:true, characterData:true, subtree:true});
  }

  const mainImg = document.querySelector('[data-gallery-main]');
  const stickyImg = bar.querySelector('[data-sticky-atc-img]');
  if(mainImg && stickyImg){
    new MutationObserver(function(){ stickyImg.src = mainImg.src; })
      .observe(mainImg, {attributes:true, attributeFilter:['src']});
  }

  bar.querySelector('[data-sticky-atc-btn]').addEventListener('click', function(){ realBtn.click(); });

  /* --- Size picker --- */
  const sizeBtn = document.querySelector('[data-sticky-atc-size-btn]');
  const sizeLabelEl = sizeBtn ? sizeBtn.querySelector('[data-sticky-atc-size]') : null;
  const panel = document.querySelector('[data-sticky-atc-size-panel]');
  if(!sizeBtn || !panel) return;

  let overlay = document.querySelector('.rivelia-sticky-atc__overlay');
  if(!overlay){
    overlay = document.createElement('div');
    overlay.className = 'rivelia-sticky-atc__overlay';
    document.body.appendChild(overlay);
  }

  function findRealSizeSection(){
    return Array.from(document.querySelectorAll('.variant-section.product-variant-block')).find(function(sec){
      return sec.querySelector('.product-size-button__label');
    });
  }

  function buildPanel(){
    const realSection = findRealSizeSection();
    if(!realSection) return;
    const chips = Array.from(realSection.querySelectorAll('.product-size-button__label'));
    let html = '<div class="rivelia-sticky-atc__size-panel-title"><span>Choose a size</span><button type="button" class="rivelia-sticky-atc__size-panel-close" data-close-panel>&times;</button></div><div class="rivelia-sticky-atc__size-grid">';
    chips.forEach(function(chip){
      const val = chip.getAttribute('data-option-value');
      const isActive = chip.classList.contains('active');
      const isSoldout = chip.classList.contains('soldout');
      html += '<button type="button" class="rivelia-sticky-atc__size-chip' + (isActive?' active':'') + (isSoldout?' soldout':'') + '" data-size-value="' + val + '"' + (isSoldout?' disabled':'') + '>' + val + '</button>';
    });
    html += '</div>';
    panel.innerHTML = html;
  }

  function updateSizeLabel(){
    const realSection = findRealSizeSection();
    if(!realSection || !sizeLabelEl) return;
    const activeChip = realSection.querySelector('.product-size-button__label.active');
    sizeLabelEl.textContent = activeChip ? ('Size ' + activeChip.getAttribute('data-option-value')) : 'Size';
  }

  function openPanel(){
    buildPanel();
    panel.classList.add('open');
    overlay.classList.add('open');
    sizeBtn.classList.add('open');
  }
  function closePanel(){
    panel.classList.remove('open');
    overlay.classList.remove('open');
    sizeBtn.classList.remove('open');
  }

  sizeBtn.addEventListener('click', openPanel);
  overlay.addEventListener('click', closePanel);
  panel.addEventListener('click', function(e){
    if(e.target.closest('[data-close-panel]')){ closePanel(); return; }
    const chip = e.target.closest('[data-size-value]');
    if(!chip || chip.disabled) return;
    const val = chip.getAttribute('data-size-value');
    const realSection = findRealSizeSection();
    if(!realSection) return;
    const realChip = Array.from(realSection.querySelectorAll('.product-size-button__label')).find(function(c){ return c.getAttribute('data-option-value') === val; });
    if(realChip) realChip.click();
    setTimeout(function(){ updateSizeLabel(); closePanel(); }, 150);
  });

  updateSizeLabel();
  document.addEventListener('click', function(e){
    if(e.target.closest('.variant-option, .product-size-button__label')) setTimeout(updateSizeLabel, 100);
  });
})();

/* Rivelia size dropdown: UI layer on top of the existing size chips. The chips keep owning ALL variant logic
   (checked input, variant id, availability, sticky bar); the dropdown only mirrors them and forwards clicks. */
(function initSizeDropdown(){
  const container=document.querySelector('[data-product-container]'); if(!container) return;
  const group=container.querySelector('[data-size-select]'); if(!group) return;
  const section=group.closest('.variant-section'); if(!section) return;
  const chipList=()=>Array.from(group.querySelectorAll('.product-size-button__label'));
  const chips0=chipList(); if(!chips0.length) return;
  /* display-only UK equivalents (same as the size chart); unknown sizes are shown exactly as the variant value */
  const UK={xs:6,s:8,m:10,l:12,xl:14,'2xl':16,xxl:16};
  const fmt=v=>{v=String(v||'').trim();const n=UK[v.toLowerCase()];return n?v+' / UK '+n:v;};
  /* a size counts as chosen if the visitor clicked one, the URL names a variant, or there is only one size */
  let chosen=group.hasAttribute('data-size-preselected')||chips0.length===1;

  const wrap=document.createElement('div'); wrap.className='rvl-size-dd';
  wrap.innerHTML='<button type="button" class="rvl-size-dd__btn" role="combobox" aria-haspopup="listbox" aria-expanded="false" aria-controls="rvl-size-list"><span class="rvl-size-dd__val"></span><svg class="rvl-size-dd__chev" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg></button><ul class="rvl-size-dd__list" id="rvl-size-list" role="listbox" aria-label="Select your size"></ul>';
  const btn=wrap.querySelector('.rvl-size-dd__btn'), val=wrap.querySelector('.rvl-size-dd__val'), list=wrap.querySelector('.rvl-size-dd__list');
  const msg=document.createElement('p'); msg.className='rvl-size-dd__msg'; msg.setAttribute('role','alert'); msg.textContent='Please select your size.';
  group.parentNode.insertBefore(wrap,group); group.parentNode.insertBefore(msg,group);

  const opts=chips0.map((chip,i)=>{
    const li=document.createElement('li'); li.className='rvl-size-dd__opt'; li.setAttribute('role','option'); li.id='rvl-size-opt-'+i;
    const t=document.createElement('span'); t.className='rvl-size-dd__txt'; t.textContent=fmt(chip.dataset.optionLabel||chip.dataset.optionValue);
    const tag=document.createElement('span'); tag.className='rvl-size-dd__tag'; tag.textContent='Sold out';
    li.appendChild(t); li.appendChild(tag); list.appendChild(li); return li;
  });

  let focusIdx=-1;
  const isOpen=()=>wrap.classList.contains('open');
  const enabled=i=>opts[i]&&opts[i].getAttribute('aria-disabled')!=='true';
  function sync(){
    const cs=chipList(); const active=cs.find(c=>c.classList.contains('active'));
    opts.forEach((li,i)=>{
      const c=cs[i]; if(!c) return;
      const sel=chosen&&c===active, sold=c.classList.contains('soldout');
      li.setAttribute('aria-selected',sel?'true':'false');
      li.setAttribute('aria-disabled',sold&&!sel?'true':'false');
      li.toggleAttribute('data-sold',sold);
    });
    const shown=chosen&&active;
    val.textContent=shown?fmt(active.dataset.optionLabel||active.dataset.optionValue):'Select your size';
    wrap.classList.toggle('has-value',!!shown);
  }
  function setFocus(i){
    focusIdx=i; opts.forEach((li,k)=>li.classList.toggle('focus',k===i));
    if(i<0){btn.removeAttribute('aria-activedescendant');return;}
    const li=opts[i]; btn.setAttribute('aria-activedescendant',li.id);
    if(li.offsetTop<list.scrollTop) list.scrollTop=li.offsetTop;
    else if(li.offsetTop+li.offsetHeight>list.scrollTop+list.clientHeight) list.scrollTop=li.offsetTop+li.offsetHeight-list.clientHeight;
  }
  function open(){
    if(isOpen()) return; sync(); wrap.classList.add('open'); btn.setAttribute('aria-expanded','true');
    let i=opts.findIndex(li=>li.getAttribute('aria-selected')==='true'); if(i<0) i=opts.findIndex((li,k)=>enabled(k));
    setFocus(i);
    /* keep the whole list on screen (above the sticky mobile bar when it is showing) */
    requestAnimationFrame(()=>{
      const bar=document.querySelector('[data-sticky-atc].show'), r=list.getBoundingClientRect();
      const limit=window.innerHeight-(bar?bar.offsetHeight:0)-8;
      if(r.bottom>limit) window.scrollBy({top:r.bottom-limit,behavior:'smooth'});
    });
  }
  function close(){wrap.classList.remove('open');btn.setAttribute('aria-expanded','false');setFocus(-1);}
  function clearError(){wrap.classList.remove('error');msg.classList.remove('show');}
  function showError(){
    wrap.classList.add('error'); msg.classList.add('show');
    try{wrap.scrollIntoView({behavior:'smooth',block:'center'});}catch(e){}
    open();
  }
  function choose(i){
    if(!enabled(i)) return;
    chosen=true; clearError();
    chipList()[i].click();   /* existing selectVisual() updates the checked input, variant id, URL and availability */
    sync(); close(); btn.focus();
  }
  function move(dir){
    let i=focusIdx; for(let n=0;n<opts.length;n++){i=(i+dir+opts.length)%opts.length; if(enabled(i)){setFocus(i);return;}}
  }

  btn.addEventListener('click',()=>{isOpen()?close():open();});
  list.addEventListener('click',e=>{const li=e.target.closest('.rvl-size-dd__opt'); if(li) choose(opts.indexOf(li));});
  document.addEventListener('click',e=>{if(isOpen()&&!wrap.contains(e.target)&&!(e.target.closest&&e.target.closest('[data-sticky-atc-btn]'))) close();});
  btn.addEventListener('keydown',e=>{
    const k=e.key;
    if(k==='Escape'){if(isOpen()){e.preventDefault();close();}return;}
    if(k==='Tab'){close();return;}
    if(k==='ArrowDown'||k==='ArrowUp'){e.preventDefault(); if(!isOpen()){open();return;} move(k==='ArrowDown'?1:-1);return;}
    if((k==='Enter'||k===' ')&&isOpen()){e.preventDefault(); if(focusIdx>=0) choose(focusIdx);}
  });

  /* mirror every change made by the existing logic (colour change, availability, sticky-bar picker) */
  new MutationObserver(sync).observe(group,{subtree:true,attributes:true,attributeFilter:['class']});
  container.addEventListener('click',e=>{
    if(!chosen&&group.contains(e.target)&&e.target.closest('.product-size-button__label')){chosen=true;clearError();sync();}
  });

  /* never add to cart until a size has been chosen (also covers the sticky-bar button, which calls the real one) */
  function guard(e){if(chosen) return; e.preventDefault(); e.stopImmediatePropagation(); showError();}
  document.addEventListener('click',e=>{if(e.target.closest&&e.target.closest('[data-atc-btn]')) guard(e);},true);
  document.addEventListener('submit',e=>{if(e.target.closest&&e.target.closest('[data-product-form]')) guard(e);},true);

  section.classList.add('rvl-size-dd-on');
  if(!chosen){
    chips0.forEach(c=>c.classList.remove('active'));
    const stickyLabel=document.querySelector('[data-sticky-atc-size]'); if(stickyLabel) stickyLabel.textContent='Size';
  }
  sync();
})();
